const apiKeys = {
  headerButtons: {
    create: 'Criar',
  },
  table: {
    headers: {
      alias: 'Nome',
      createdAt: 'Criado em',
      accessTokenExpiration: 'Expiração da sessão',
      permissions: 'Permissões',
      editable: 'Editável',
    },
    actions: {
      delete: 'Excluir',
      generateToken: 'Gerar token',
    },
    expiration: {
      default: 'Padrão',
    },
    filters: {
      editable: {
        label: 'Editável',
        isEditable: 'Editável',
        isNotEditable: 'Não editável',
      },
    },
    permissions: {
      all: 'Acesso total',
    },
    editable: {
      yes: 'Sim',
      no: 'Não',
    },
  },
  create: {
    title: 'Criar chave de API',
    error: 'Falha ao criar chave de API',
    unlimitedWarning: 'Tokens sem limite permanecem ativos até serem excluídos. Recomendamos definir um período de expiração.',
    tabs: {
      info: 'Informações',
      permissions: 'Permissões',
    },
    expirationUnits: {
      minutes: 'Minutos',
      hours: 'Horas',
      days: 'Dias',
      unlimited: 'Sem limite',
    },
    fields: {
      alias: 'Nome',
      expiresAt: 'Expiração da sessão',
    },
  },
  newSecretModal: {
    title: 'Nova chave secreta',
    subtitle: 'Copie a chave secreta para a área de transferência e guarde-a em local seguro.',
    warning: 'Atenção: Após fechar a janela, você não poderá visualizar esta chave secreta novamente.',
    secretKeyLabel: 'Chave secreta',
    copy: 'Copiar',
    copySuccess: 'Copiado para a área de transferência',
    copyError: 'Falha ao copiar',
    done: 'Concluído',
  },
  delete: {
    success: 'Chave de API excluída',
    error: 'Falha ao excluir chave de API',
    confirmModal: {
      title: 'Excluir chave de API',
      body: 'Tem certeza de que deseja excluir "{{ alias }}"? Todos os tokens ativos criados a partir dessa chave deixarão de funcionar imediatamente.',
      bodyMany:
        'Tem certeza de que deseja excluir {{ count }} chaves de API? Todos os tokens ativos criados a partir dessas chaves deixarão de funcionar imediatamente.',
      confirm: 'Excluir',
    },
  },
  edit: {
    title: 'Editar "{{ alias }}"',
    success: 'Chave de API atualizada',
    error: 'Falha ao atualizar chave de API',
  },
  generateToken: {
    title: 'Inserir chave secreta - {{ alias }}',
    subTitle: 'Insira a chave secreta e clique em gerar para criar um token e um código curto.',
    successTitle: 'Novo token de API e código curto',
    submit: 'Gerar',
    cancel: 'Cancelar',
    done: 'Concluído',
    copy: 'Copiar',
    copySuccess: 'Copiado para a área de transferência',
    copyError: 'Falha ao copiar',
    error: 'Falha ao gerar token',
    instructions: 'Cole seu Client Secret armazenado para gerar um novo token de acesso.',
    tokenWarning: 'Atenção: Após fechar a janela, você não poderá visualizar este token novamente.',
    shortCodeWarning: 'Atenção: Após fechar a janela, você não poderá visualizar este código curto novamente.',
    fields: {
      clientId: 'Client ID',
      clientSecret: 'Client Secret',
      clientSecretPlaceholder: 'Cole sua chave secreta',
      token: 'Token de acesso',
      shortCode: 'Código curto',
      expiration: 'Expiração',
      tokenInfo: 'Copie o token para a área de transferência e guarde-o em local seguro.',
      shortCodeInfo: 'Copie o código curto para a área de transferência e guarde-o em local seguro.',
    },
  },
};

export default apiKeys;
